






































import { computed, defineComponent } from '@vue/composition-api';
import { ChevronLeftIcon, ErrorCircleIcon } from 'tdesign-icons-vue';
import { SMH } from '@/renderer/scripts/smh';
import { isDisabledAllAuth } from '@/renderer/scripts/utils/tools/index';
interface DataProp {
  allowExternalUser: boolean;
  authRoleId: number;
}
export default defineComponent({
  name: 'InviteMembersSetting',
  components: {
    ChevronLeftIcon,
    ErrorCircleIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: true,
    },
    data: {
      required: true,
      type: Object,
    },
  },
  setup(
    props: {
      show: boolean;
      data: DataProp;
    },
    context,
  ) {
    const store = context.root.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const allowExternalUserData = computed({
      get() {
        let str = '';
        // 如果是个人版的话，就不需要拿allowExternalUser的数据了，只能选择所以用户
        if (store.getters.editionFlag === 'personal') {
          str = 'all';
          // } if (store.getters.editionFlag === 'enterprise') {
          // str = 'internal';
          // str = props.data.allowExternalUser ? 'all' : 'internal';
        } else {
          str = props.data.allowExternalUser ? 'all' : 'internal';
        }
        return str;
      },
      set(val) {
        const res = val === 'all';
        context.emit('change', 'allowExternalUser', res);
      },
    });
    const roleIdData = computed({
      get() {
        return props.data.authRoleId;
      },
      set(val) {
        context.emit('change', 'authRoleId', val);
      },
    });

    // 由于协作群组不能进行添加共享成员，因此所有有共享权限的角色都要过滤掉，禁止访问权限也要过滤
    const roleList = computed(() =>
      store.getters.roles.filter((role: SMH.Role) => !role.canAuthorize && !isDisabledAllAuth(role)),
    );
    const onReture = () => {
      innerShow.value = false;
      context.emit('return');
    };
    const openHelp = () => {
      context.emit('open-help');
    };
    return {
      innerShow,
      allowExternalUserData,
      roleList,
      roleIdData,
      onReture,
      openHelp,
    };
  },
});
